import {Col} from 'react-bootstrap';
import {useSelector} from 'react-redux';
import {selectUser} from '../../stores/selectors/appStateSelector';
import {FmlxButton} from 'fmlx-common-ui';
import './Consolidation.scss';

const ActionBarConsolidation = ({
  onSaveClick,
  loadingSave,
  onLockAndSaveClick,
  onUnlockClick,
  onBackSelected,
  fallbackComponent,
  item,
}) => {
  const {employeeId} = item;
  const user = useSelector(selectUser);
  if (!user || !employeeId) {
    return null;
  }
  // cannot save/update consolidation if user is self
  const isSelf = user.id === employeeId;
  return (
    <>
      <Col className="action-bar--consolidation" sm={12} md={8} lg={8}>
        {!isSelf && (
          <>
            <FmlxButton
              size="xl"
              label="Save"
              type="primary"
              onClick={onSaveClick}
              disabled={item.release || loadingSave}
              showProgress={loadingSave}
              progressPosition="left"
            />

            <FmlxButton
              size="xl"
              label="Lock & Save"
              type="primary"
              onClick={onLockAndSaveClick}
              disabled={item.release || loadingSave || item.length === 0}
              showProgress={loadingSave}
              progressPosition="left"
            />
            <FmlxButton
              size="xl"
              label="Unlock"
              type="primary"
              onClick={onUnlockClick}
              disabled={loadingSave || item.length === 0}
              showProgress={loadingSave}
              progressPosition="left"
            />
          </>
        )}
        <FmlxButton
          size="xl"
          label="Back"
          variant="contain"
          type="primary"
          onClick={onBackSelected}
          disabled={loadingSave || item.length === 0}
          showProgress={loadingSave}
          progressPosition="left"
        />
      </Col>
    </>
  );
};

export default ActionBarConsolidation;
